import common from "../../../utils/common";
import c from "../../../utils/constants";

class userChildrenController {
  constructor() {
    "ngInject"
    
  }
  
  $onInit() {
    
    this.gridOptions = {
      dataSource: this.children,
      sortable: true,
      pageable: false,
      resizable: true,
      noRecords: {
        template: "No Children."
      },
      columns: [
        { field: "firstName", title: "First Name", filterable: false, width: "6rem" },
        { field: "lastName", title: "Last Name", filterable: false, width: "6rem" },
        { field: "dateOfBirth", title: "Date of Birth", filterable: false, width: "4rem", template: `#= kendo.toString(new Date(dateOfBirth), 'dd-MM-yyyy') #` },
        { field: "gender", title: "Gender", filterable: false, width: "4rem", template: (dataItem) => `${this._getGenderText(dataItem.gender)}` },
        { field: "allergyDetails", title: "Allergy Details", filterable: false, width: "6rem" },
        { field: "aboutMe", title: "More Details", filterable: false, width: "6rem" },
      ]
    }
  }
  
  _getGenderText(gender) {
    switch(gender) {
      case c.gender.MALE:
        return "Male";
      case c.gender.FEMALE:
        return "Female";
      case c.gender.UNSPECIFIED:
        return "-";
        
    }
  }
  
}

export default userChildrenController;



/** WEBPACK FOOTER **
 ** E:/JUGGLE_STREET/Juggle-Street-Deployment-All/JSBIGFOOTFRONTEND-BACKEND/admin-frontend/client/app/common/Components/user-children/user-children.controller.js
 **/